// Date lookup for the /bookings?selected_booking= deep link, shared by every
// bookings view. Resolves null when the slot isn't in the current group (the
// lambda answers 401) or the request fails, so callers never hang.

import axios from 'axios'
import { Auth } from 'aws-amplify'
import apiConfig from '@/api-config'
import { currentGroupId } from '@/util/groupDataCache'
import { bookingDateFromLookup, toIsoDate } from '@/util/bookingsView'

const API_LOCATION: string = (apiConfig as any).API_LOCATION

export async function lookupBookingDate(bookingId: string | number): Promise<string | null> {
  try {
    const session = await Auth.currentSession()
    const companyId = localStorage.getItem('companyId')
    const url = `${API_LOCATION}companies/${companyId}/groups/${currentGroupId()}/bookings/${bookingId}`
    const res = await axios.get(url, { headers: { Authorization: session.getIdToken().getJwtToken() } })
    return bookingDateFromLookup(res.data)
  } catch (e) {
    return null
  }
}

// The deep link's date: the ?date= the link carried (transaction rows send it),
// else a lookup. Links without a date (Tickets, Event logs, Dashboard) look it up.
export async function resolveDeepLinkDate(bookingId: string | number, urlDate?: string | null): Promise<string | null> {
  return toIsoDate(urlDate || null) || lookupBookingDate(bookingId)
}

// The deep-linked slot's row from an unfiltered fetch of its date, for when the
// view's own filters hide it: the drawer still opens and the filters stay as set.
// Resolves null when the slot isn't on that date or the request fails.
export async function fetchDeepLinkSlot(bookingId: string | number, date: string): Promise<any | null> {
  try {
    const session = await Auth.currentSession()
    const companyId = localStorage.getItem('companyId')
    const url = `${API_LOCATION}companies/${companyId}/groups/${currentGroupId()}/bookings/calendar?day=${date}&status=&game=`
    const res = await axios.get(url, { headers: { Authorization: session.getIdToken().getJwtToken() } })
    const rows = (res.data && res.data.bookings) || []
    return rows.find((row: any) => String(row.id) === String(bookingId)) || null
  } catch (e) {
    return null
  }
}
